import AppDispatcher from '../dispatcher/AppDispatcher';
import { EventEmitter } from 'events';
import { CHANGE_EVENT } from '../constants/AppConstants';
import {
  REQUEST_CREATE_M_TRACK_CONSENT,
  REQUEST_CREATE_M_TRACK_CONSENT_ERROR,
  REQUEST_CREATE_M_TRACK_CONSENT_SUCCESS,
  REQUEST_M_TRACK_CONSENT,
  REQUEST_M_TRACK_CONSENT_ERROR,
  REQUEST_M_TRACK_CONSENT_SUCCESS,
  REQUEST_M_TRACK_WHITELIST,
  REQUEST_M_TRACK_WHITELIST_ERROR,
  REQUEST_M_TRACK_WHITELIST_SUCCESS,
} from '../constants/MTrackConstants';
import {
  createUserTrackerConsent,
  getUserTrackerConsentStatus,
  getWhitelistStatus,
} from '../utils/ThirdPartyApiUtils';

let isMtrackWhitelisted = false;
let isMTrackWhitelistLoaded = false;
let isMTrackWhitelistError = null;

let isMTrackConsented = false;
let isMTrackConsentLoaded = false;
let isMTrackConsentError = false;
let mTrackConsentError = null;

let isMTrackCreatingConstent = false;
let isMTrackConsentCreated = false;
let isMTrackConsentCreatedFailed = false;

class MTrackStore extends EventEmitter {
  constructor() {
    super();
    this.dispatchToken = AppDispatcher.register(
      this.dispatcherCallback.bind(this)
    );
  }
  emitChange() {
    this.emit(CHANGE_EVENT);
  }
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }

  getMTrackWhitelistLoaded() {
    return isMTrackWhitelistLoaded;
  }

  getMTrackConsentLoaded() {
    return isMTrackConsentLoaded;
  }

  isMtrackWhitelisted() {
    return isMtrackWhitelisted;
  }

  isMTrackConsented() {
    return isMTrackConsented;
  }

  isMTrackCreatingConstent() {
    return isMTrackCreatingConstent;
  }

  isMTrackConsentCreated() {
    return isMTrackConsentCreated;
  }

  isMTrackConsentCreatedFailed() {
    return isMTrackConsentCreatedFailed;
  }

  isMTrackWhitelistError() {
    return isMTrackWhitelistError;
  }

  isMTrackConsentError() {
    return isMTrackConsentError;
  }

  getMTrackConsentError() {
    return mTrackConsentError;
  }

  dispatcherCallback({ action }) {
    const actionType = action.actionType;
    const actionData = action.data;
    switch (actionType) {
      case REQUEST_M_TRACK_WHITELIST:
        isMTrackWhitelistLoaded = false;
        getWhitelistStatus();
        break;
      case REQUEST_M_TRACK_WHITELIST_SUCCESS:
        isMTrackWhitelistLoaded = true;
        isMtrackWhitelisted = actionData;
        this.emitChange();
        break;
      case REQUEST_M_TRACK_WHITELIST_ERROR:
        isMTrackWhitelistLoaded = true;
        isMTrackWhitelistError = actionData;
        this.emitChange();
        break;
      case REQUEST_M_TRACK_CONSENT:
        isMTrackConsentLoaded = false;
        getUserTrackerConsentStatus();
        break;
      case REQUEST_M_TRACK_CONSENT_SUCCESS:
        isMTrackConsentLoaded = true;
        isMTrackConsented = actionData;
        this.emitChange();
        break;
      case REQUEST_M_TRACK_CONSENT_ERROR:
        isMTrackConsentLoaded = true;
        isMTrackConsentError = true;
        if (actionData?.Errors?.length > 0) {
          mTrackConsentError = actionData.Errors[0]?.Message;
        }
        if (actionData?.error) {
          mTrackConsentError = actionData.message;
        }
        this.emitChange();
        break;
      case REQUEST_CREATE_M_TRACK_CONSENT:
        isMTrackConsentCreatedFailed = false;
        isMTrackConsentCreated = false;
        createUserTrackerConsent();
        break;
      case REQUEST_CREATE_M_TRACK_CONSENT_SUCCESS:
        isMTrackConsentCreated = true;
        this.emitChange();
        break;
      case REQUEST_CREATE_M_TRACK_CONSENT_ERROR:
        isMTrackConsentCreatedFailed = true;
        this.emitChange();
        break;
      default: {
        break;
      }
    }
  }
}

export default new MTrackStore();
